// TODO: Refactor if time allows. The intention was to have centralized
// configuration for the Radix sizing, but the issue now is the varying
// available sizes for different Radix components. e.g. tab nav 1-2,
// textfield 1-3, iconbutton 1-4, card 1-5 and so on...
// So different sizing categories require their own enums.
export enum DexRadixSize {
  SMALL = '1',
  DEFAULT = '2',
  LARGE = '3',
}

export const READONLY_TOOLTIP = 'Reserve editing to use this feature'
